import React, { Component } from 'react';
import "./footer.css";
import HavayarLogoSignImage from "../../assets/images/havayar/havayar_logo_sign-white.svg";
import { Link } from "react-router-dom";

export default class DesktopFooter extends Component {

    render() {
        return (
            <footer >
                <div className="col footerbox">
                    <ul className="footerlink">
                        <div className="row">
                            <div className="col-1">
                                <img style={{ marginTop: -7 }} src={HavayarLogoSignImage} alt="..." />
                            </div>
                            <div className="col-7" >
                                <li><Link to="/about">هوایار</Link></li>
                                <li><Link to="/serviceRequest">خدمات پس از فروش</Link></li>
                                <li><Link to="/aboutApp">درباره اپلیکیشن</Link></li>
                                <li><a target="_blank" href="../assets/pdf/AppUserManual.pdf" download>راهنمای اپلیکیشن</a></li>
                                <li><Link to="/news">اخبار</Link></li>
                            </div>
                            <div className="col-4">
                                <li>
                                    <Link to="">
                                        کلیه حقوق برای هوایار محفوظ است
                                        <i className="far fa-copyright"></i>
                                        <span className="copyright-year">۱۴۰۱</span>
                                    </Link>
                                </li>
                                <li className="footertext">
                                    تلفن : ۴۱۹۷۶(۰۲۱)
                                </li>
                                <li className="footertext">
                                    ایمیل : info@havayar.com
                                </li>
                            </div>
                        </div>
                    </ul>
                </div>
            </footer>
        );
    }
}

